import { axios } from '@/utils/request'

export function getExamList (queryParam) {
  return axios({
    url: '/ReadWriteExam/list',
    method: 'get',
    params: queryParam
  })
}

export function getSimulationList (queryParam) {
  return axios({
    url: '/ReadWriteExam/simulation',
    method: 'get',
    params: queryParam
  })
}

export function getUnitExamList (queryParam) {
  return axios({
    url: '/ReadWriteExam/listAll',
    method: 'get',
    params: queryParam
  })
}

export function getHistoryExamList (queryParam) {
  return axios({
    url: '/ReadWriteExam/history',
    method: 'get',
    params: queryParam
  })
}

export function getGroupList (queryParam) {
  return axios({
    url: '/ReadWriteExam/groupList',
    method: 'get',
    params: queryParam
  })
}

export function getTaskList (queryParam) {
  return axios({
    url: '/ReadWriteExam/taskList',
    method: 'get',
    params: queryParam
  })
}

export function getHistoryTaskList (queryParam) {
  return axios({
    url: '/ReadWriteExam/historyTask',
    method: 'get',
    params: queryParam
  })
}
